import { cn, createIconElement } from '@/lib';
import ChevronRight from '@/assets/icons/ic-chevron-right.svg';
import ImageIcon from '@/assets/icons/ic-image.svg';

interface PostPickerButtonProps {
    selectedPostUrls: string[];
    onClick: () => void;
}

/**
 * PostPickerButton - Button that displays selected posts and opens the post picker modal
 */
export const PostPickerButton = ({ selectedPostUrls, onClick }: PostPickerButtonProps) => {
    const hasSelectedPosts = selectedPostUrls.length > 0;
    const displayText = hasSelectedPosts
        ? `${selectedPostUrls.length} post${selectedPostUrls.length > 1 ? 's' : ''} selected`
        : 'On all posts';

    const ChevronRightIcon = createIconElement(ChevronRight, {
        className: 'text-gray',
    });

    return (
        <button
            type='button'
            onClick={onClick}
            className={cn(
                'flex h-12 w-full cursor-pointer items-center gap-2 rounded-md border px-3 py-2 transition duration-200',
                'bg-canvas border-disabled',
                'hover:border-brand-main',
                'focus:border-brand-main focus:shadow-material-focus-glow-default focus:outline-none'
            )}
        >
            {/* Image Section */}
            <div className='relative flex items-center'>
                {hasSelectedPosts ? (
                    <>
                        {selectedPostUrls.slice(0, 3).map((url, index) => (
                            <img
                                key={`post-${url.slice(url.lastIndexOf('/') + 1)}`}
                                src={url}
                                alt={`Selected post ${index + 1}`}
                                className={cn(
                                    'border-canvas size-8 rounded-md border-2 object-cover shadow-sm',
                                    index > 0 && '-ml-5'
                                )}
                                style={{ zIndex: 1 + index }}
                            />
                        ))}
                    </>
                ) : (
                    <div className='bg-neutral-subtle flex size-8 items-center justify-center rounded-md'>
                        <ImageIcon className='text-gray size-5' />
                    </div>
                )}
            </div>

            {/* Text Section */}
            <span className='text-body-sm text-dark flex-1 text-left font-medium'>{displayText}</span>

            {/* Arrow Icon */}
            {ChevronRightIcon}
        </button>
    );
};
